import React, { useContext, useEffect } from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { LawTable } from './List';
import { CreateLaw } from './Create';
import { LawSettings } from './Settings';
import { EditLaw } from './Edit';
import { EditLawChecklist } from './Checklist';
import { SupportInvitesTable } from './SupportInvites/SupportInvitesTable';
import { SendoutsTable } from './Sendouts/SendoutsTable';
import { UserContext, AdminFeature, AccessLevel } from '../../../../Context/UserContext/UserContext';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';
import { InformationBoard } from './InformationBoard/InformationBoard';
import { CreateInformationBoard } from './InformationBoard/Create';
import { EditInformationBoard } from './InformationBoard/Edit';

export const LawPortal = () => {
  const { hasAccessToFeature } = useContext(UserContext);
  const { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);
  useEffect(() => {
    setHeader(formatMessage({ id: 'admin.law-portal.header', defaultMessage: 'Lawportal' }), [
      {
        title: formatMessage({ id: 'admin.law-portal.subMenu.laws', defaultMessage: 'Laws' }),
        to: '/admin/law-portal/laws',
      },
      {
        title: formatMessage({ id: 'admin.law-portal.subMenu.sendouts', defaultMessage: 'Sendouts' }),
        to: '/admin/law-portal/sendouts',
      },
      {
        title: formatMessage({ id: 'admin.law-portal.subMenu.settings', defaultMessage: 'Settings' }),
        to: '/admin/law-portal/settings',
      },
      {
        title: formatMessage({ id: 'admin.law-portal.subMenu.supportInvites', defaultMessage: 'Support invites' }),
        to: '/admin/law-portal/support-invites',
      },
       {
        title: formatMessage({ id: 'admin.law-portal.subMenu.informationBoard', defaultMessage: 'Information board' }),
        to: '/admin/law-portal/information-board',
      },
    ]);
  }, [setHeader, formatMessage]);
  return (
   <Routes>
      <Route path="laws" element={<LawTable />} />
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="laws/new" element={<CreateLaw />} />
      )}
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="laws/:id/checklist" element={<EditLawChecklist />} />
      )}
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="laws/:id" element={<EditLaw />} />
      )}
      <Route path="settings" element={<LawSettings />} />
      <Route path="support-invites" element={<SupportInvitesTable />} />
      <Route path="sendouts" element={<SendoutsTable />} />
       <Route path="information-board" element={<InformationBoard/>} />
        {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="information-board/new" element={<CreateInformationBoard />} />
      )}
       {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="information-board/:id" element={<EditInformationBoard />} />
      )}
      <Route path="*" element={<Navigate to="laws" replace />} />
    </Routes>
  );
};
